import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { GetEnumElementFromString } from "motw_core/Utils/EnumUtils";
import * as React from "react";
import { HandleNewDreamEditorLaunch } from "source/app/presentation/MainPanel/Dreams/Add/Helpers/HandleNewDreamEditorLaunch";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import {
    defaultDreamPrefix,
    GetDreamAttributePrefix,
    GetDreamAttributeTextColor
} from "../../../DreamAttributeIcon/AttributeMap/AttributeMap";

export function RegularNewDreamLink({
    dreamsState,
}: {
    dreamsState: IDreamsState;
}) {
    return (
        <IconWithText
            iconSuffix={EGlyphicon["plus"]}
            whenClicked={() =>
                HandleNewDreamEditorLaunch(undefined, dreamsState)
            }
            displayAsBlock={false}
            withClass={GetStyleClass(undefined)}
        >
            {defaultDreamPrefix}
        </IconWithText>
    );
}

export function ProblemNewDreamLink({
    dreamsState,
}: {
    dreamsState: IDreamsState;
}) {
    return <NewDreamLink dreamAttribute={EDA.problem} {...{ dreamsState }} />;
}

export function DynamicNewDreamLink({
    dreamsState,
}: {
    dreamsState: IDreamsState;
}) {
    const selectedDreamAttribute = GetSelectedDreamAttribute(dreamsState);

    if (!selectedDreamAttribute) {
        return null;
    }

    return (
        <NewDreamLink
            dreamAttribute={selectedDreamAttribute}
            {...{ dreamsState }}
        />
    );
}

function NewDreamLink({
    dreamAttribute,
    dreamsState,
}: {
    dreamAttribute: EDA;
    dreamsState: IDreamsState;
}) {
    const dreamTypeText = GetDreamAttributePrefix([EDA[dreamAttribute]]);

    return (
        <IconWithText
            iconSuffix={EGlyphicon["plus"]}
            whenClicked={() =>
                HandleNewDreamEditorLaunch(dreamAttribute, dreamsState)
            }
            displayAsBlock={false}
            withClass={GetStyleClass(dreamAttribute)}
        >
            {dreamTypeText}
        </IconWithText>
    );
}

export function GetSelectedDreamAttribute(dreamsState: IDreamsState) {
    const { selectedAttributes } = dreamsState;

    const selectedDreamAttribute = selectedAttributes.length === 0
        ? undefined
        : GetEnumElementFromString(EDA, selectedAttributes[0]);
    return selectedDreamAttribute;
}

function GetStyleClass(dreamAttribute: EDA | undefined) {
    const color = dreamAttribute
        ? GetDreamAttributeTextColor(dreamAttribute)
        : `inherit`;

    return StyleClass(`ShowNewDreamButton_${dreamAttribute}`, {
        color,
        margin: `0px 10px`,
    });
}
